/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useState, useEffect, useRef, useCallback, Component } from 'react'
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { Auth, API, Hub } from "aws-amplify"
import { AmplifyAuthenticator } from '@aws-amplify/ui-react';

import { useSnackbar } from 'notistack';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';
import Header from './header';

import { currUsersInfo } from '../graphql/queries.js';
import './layout.scss';

class CeresErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {errorMsg: ''};
    }

    static getDerivedStateFromError(error) {
        return {errorMsg: error.toString()};
    }
    componentDidCatch(error, info) {
        console.log('body error');
        console.log(error, info.componentStack);
    }
    render() {
        if (this.state.errorMsg) {
            return (
              <center>
                <h3 style={{marginTop: '30px', color: '#000000'}}>Sorry! Something went wrong. </h3>
                <span style={{color: '#000000'}}>This event has been logged.  We apologize for the issue, please contact tech support for more information.</span>
              </center>
            );
        }
        return this.props.children;
    }
}

// this uses hooks to store the callback function
//    when it changes and reset the timer when the delay changes
// this keeps page timer from being reset with every render
const useInterval = (callback, delay) => {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
  }

const Layout = ( props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [uname, setUname] = useState('')
    const [uid, setUid] = useState('')

    const [hdata, setHdata] = useState({"data":{"getCurrentUser":{"loading": "true"}}});
    // const vdebug = true;    // test and dev settings
    const vdebug = false;  // production settings

    // get the username and uid from session accessToken
    // using memoized fetchUname to keep renders from
    //   triggering useeffects listing it in dependencies
    // NOTE: this could be simply defined in the useeffect
    //   without usecallback since it is only used by one useeffect
    const fetchUname = useCallback(async () => {
        try {
            const {accessToken} = await Auth.currentSession();

            const uname = accessToken.payload['username'];
            if (vdebug) { console.log(uname); }
            setUname(uname);

            const uid = accessToken.payload['sub'];
            if (vdebug) { console.log(uid);  }
            setUid(uid);
        } catch (error) {
            if (vdebug) { console.log("Failed uname fetch", error); }
            setUname('no user');
            }
        }, [vdebug]);

    // every time the page loads
    useEffect(() => {
        fetchUname();
    }, [fetchUname, vdebug]);

    // log out user after an hour
    useInterval(() => {
        async function signOut() {
          try {
              await Auth.signOut({ global: true });
          } catch (error) {
              console.log('error signing out: ', error);
          }
        };

        signOut();
        // fetchUname();
    }, (uname === 'no user' || uname === '')? null: 3600000);

  // get the user record from dynamodb
  // everytime the user changes to a valid name
  useEffect(() => {
      async function fetchUser() {
        try {
          const result = await API.graphql({query: currUsersInfo});
          if (vdebug) { console.log(result); }
          setHdata(result);

          } catch (error) {
            if (vdebug) { console.log("Failed user record", error); }
          }
        };

      if (uname !== 'no user' && uname !=='') {
          fetchUser();
    }
  }, [uname, vdebug]);

  // subscribe to any changes in auth status
  useEffect(() => {
      const hubListener = (data) => {
          switch (data.payload.event) {
          case 'signIn':
              if (vdebug) { console.log('user signed in'); }
              enqueueSnackbar(`Sign-on successful`, {variant: 'success'});
              window.location.reload();
              break;
          case 'tokenRefresh_failure':
              if (vdebug) { console.log('user timed out'); }
              setUname('no user');
              window.location.reload();
              // navigate("/");
              break;
          case 'signOut':
              if (vdebug) { console.log('user signed out'); }
              setUname('no user');
              enqueueSnackbar(`user logged off`, {variant: 'success'});
              break;
          case 'tokenRefresh':
              if (vdebug) { console.log('user refreshed session'); }
              break;
          default:
              console.log('Uncaught Auth module hub signal', data.payload.event);
              break;
          }
      };

      Hub.listen('auth', hubListener);
      return () => {Hub.remove('auth', hubListener)};
  }, [enqueueSnackbar, vdebug]);

  return (
    <StaticQuery query={graphql`query SiteTitleQuery {
        site {
            siteMetadata {
                title
            }
        }
    }`}
    render={data => (
      <center><AmplifyAuthenticator>
      <div style={{margin: `1rem auto`, minHeight: '100vh', backgroundColor: '#eeeeee', textAlign: 'left' }} >
        <Header siteTitle={data.site.siteMetadata.title} uname={uname}/>
        <div style={{ margin: `0 auto`, padding: `50px 1.0rem 1.45rem`, maxWidth: 960, color: `#000000` }} >

          <main>
            {(hdata.data.getCurrentUser && hdata.data.getCurrentUser.userid) ?
                <>
                { ((!props.permit) || (hdata.data.getCurrentUser.agroups.includes(props.permit))) ?
                    <CeresErrorBoundary> {props.children} </CeresErrorBoundary> :
                    <center>
                      <h3 style={{marginTop: '30px'}}>Sorry! Not Permitted. </h3>
                      This user needs {props.permit} privileges to access this page.
                    </center>
                } </>:

                <>
                { (hdata.data.getCurrentUser && hdata.data.getCurrentUser.loading) ?
                    <center>
                      <h3 style={{marginTop: '30px'}}><CircularProgress /> </h3>
                    </center> :

                    <center>
                      <h3 style={{marginTop: '30px'}}>Welcome, new user! </h3>
                        <p>Your userkey is {uid}.  <br /><small>Give this userkey to your administrator to join an existing company.</small></p>
                        <p>
                        Company Setup button - (disabled while in beta)
                        <br /><small>   This will redirect you to our billing partner to setup an account.</small></p>
                    </center>
                }
                </>

            }

          </main>

          <footer style={{ paddingTop: 40 }}>
            <Divider />
            &copy; 2019-{new Date().getFullYear()}, Werner Digital Technology Inc
          </footer>
        </div>
      </div>
      </AmplifyAuthenticator></center>

    )} />  // end of render, static query
  ) // end of anonymous return
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
